module.exports = __webpack_public_path__ + "img/6.46751c70.png";